import axios from "axios";
import { UserStateInterface } from "../../../middleware/interfaces/user/user-state-interface";
import { UserAuthenticationInterface } from "../../../middleware/interfaces/user/user-authentication-interface";

export const UserAuthentication = {
  Authenticate: async (state: UserStateInterface) => {
    let serverResponse;
    if (state.data) {
      const userAuthenticationData: UserAuthenticationInterface = state.data;
      const url = "./php/user/user-authenticator-proxy.php";
      await axios
        .post(url, userAuthenticationData)
        .then((response) => {
          serverResponse = response.data;
        })
        .catch((error) => {
          serverResponse = {
            status: "error",
            header: "error",
            message: error.message,
          };
        });
    } else {
      serverResponse = "SOMETHING WENT WRONG! PLEASE CONTACT ADMIN.";
    }

    return serverResponse;
  },
};
